module.exports = __webpack_public_path__ + "static/milil-symbol-DND3_FnP-750980686eff15ea55ae9cfba667576d.png";